<template>
    <div>
        <b-modal id="createDepartment"
                 content-class="argus-glass-dialog department-dialog"
                 scrollable
                 header-close-label="Закрыть"
                 @hide="guardHide"
                 @hidden="resetDialog"
                 title="Создание отдела"
                 no-close-on-backdrop
        >
            <p v-if="loading" role="status">Загружаем отдел…</p>
            <fieldset v-show="!loading && !loadFailed" :disabled="saving" class="department-form">
                <label for="createDepartment-name">Название</label>
                <b-form-input
                        v-model="name"
                        placeholder="IT-отдел"
                        id="createDepartment-name"
                        size="sm"
                ></b-form-input>
                <label for="createDepartment-description" class="mt-2">Описание</label>
                <AppTextarea
                        v-model="description"
                        placeholder="Описание отдела"
                        id="createDepartment-description"
                        size="sm"
                ></AppTextarea>
                <div v-if="canManageNavigation">
                    <label for="defaultWorkspaceKey" class="mt-2">Главный рабочий раздел</label>
                    <b-form-select
                            id="defaultWorkspaceKey"
                            v-model="default_workspace_key"
                            :options="workspaceOptions"
                            size="sm"
                    ></b-form-select>
                    <small class="text-muted d-block mt-1">
                        Этот раздел будет предложен сотрудникам отдела как четвёртая вкладка и главное действие.
                    </small>
                </div>
                <b-form-checkbox
                        v-model="is_active"
                        switch
                        class="mt-2"
                >
                    Активен
                </b-form-checkbox>
            </fieldset>
            <template #modal-footer="{cancel}">
                <div class="department-dialog-footer">
                    <div v-if="actionError" class="department-dialog-error" role="alert">{{ actionError }}</div>
                    <div class="department-dialog-actions">
                        <b-button variant="outline-secondary" :disabled="saving" @click="cancel()">Отмена</b-button>
                        <b-button v-if="loadFailed" variant="primary" @click="loadDepartment">Повторить загрузку</b-button>
                        <b-button v-else variant="success" :disabled="saving || loading" @click="submit">
                            {{ saving ? 'Подождите…' : 'Создать' }}
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import departmentDialog from "../departmentDialog";
    import {WORKSPACE_REGISTRY} from "@/utils/workspaceRegistry";

    export default {
        mixins: [departmentDialog],
        computed: {
            canManageNavigation() {
                return this.$store.getters.isAdmin === true;
            },
            workspaceOptions() {
                return [
                    {value: null, text: 'Не задан'},
                    ...WORKSPACE_REGISTRY.map(workspace => ({
                        value: workspace.key,
                        text: workspace.label
                    }))
                ];
            }
        },
        data() {
            return {
                name: null,
                description: null,
                default_workspace_key: null,
                is_active: true
            }
        },
        methods: {
            clearForm() {
                this.name = null;
                this.description = null;
                this.default_workspace_key = null;
                this.is_active = true;
            },
            submit() {
                if (this.saving || this.loading || this.loadFailed) return;
                this.actionError = '';
                // Валидация на клиенте
                if (!this.name || this.name.trim().length < 2) {
                    this.actionError = 'Название отдела обязательно и должно содержать минимум 2 символа';
                    return;
                }

                const data = {
                    name: this.name.trim(),
                    description: this.description ? this.description.trim() : null,
                    is_active: this.is_active
                }
                if (this.canManageNavigation) {
                    data.default_workspace_key = this.default_workspace_key || null;
                }
                return this.saveDepartment('createDepartment', data, 'createDepartment');
            }
        },
        name: "CreateDepartment"
    }
</script>
